/**
 * Navegación entre días cuando hay un día seleccionado en el calendario.
 */

import type { CSSProperties } from 'react';
import { tokens } from '../../../design-system/tokens';
import { formatSelectedDayLabel } from '../calendarView.utils';

const btnStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2rem',
  height: '2rem',
  border: `1px solid ${tokens.colors.neutral[300]}`,
  borderRadius: tokens.borderRadius.md,
  backgroundColor: tokens.colors.neutral[50],
  color: tokens.colors.neutral[700],
  fontSize: tokens.typography.fontSize.base,
  cursor: 'pointer',
  padding: 0,
  fontFamily: 'inherit',
};

export interface DayNavigationBarProps {
  selectedDay: Date;
  onPrevDay: () => void;
  onNextDay: () => void;
  onClearDay: () => void;
}

export function DayNavigationBar({
  selectedDay,
  onPrevDay,
  onNextDay,
  onClearDay,
}: DayNavigationBarProps) {
  const label = formatSelectedDayLabel(selectedDay);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: tokens.spacing[3],
        marginBottom: tokens.spacing[4],
        padding: `${tokens.spacing[2]} ${tokens.spacing[3]}`,
        borderRadius: tokens.borderRadius.md,
        border: `1px solid ${tokens.colors.info.main}`,
        backgroundColor: tokens.colors.info.light,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: tokens.spacing[2], flexWrap: 'wrap' }}>
        <button type="button" aria-label="Día anterior" onClick={onPrevDay} style={btnStyle}>
          ←
        </button>
        <span
          style={{
            fontSize: tokens.typography.fontSize.sm,
            fontWeight: tokens.typography.fontWeight.semibold,
            color: tokens.colors.info.dark,
            textTransform: 'capitalize',
          }}
        >
          {label}
        </span>
        <button type="button" aria-label="Día siguiente" onClick={onNextDay} style={btnStyle}>
          →
        </button>
      </div>
      <button
        type="button"
        onClick={onClearDay}
        style={{
          ...btnStyle,
          width: 'auto',
          height: 'auto',
          padding: `${tokens.spacing[1]} ${tokens.spacing[3]}`,
          fontSize: tokens.typography.fontSize.sm,
        }}
      >
        Ver todo el mes
      </button>
    </div>
  );
}
